import React from 'react';
import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import ScrollManager from './components/ScrollManager';
import Home from './components/Home';
import PortfolioPage from './components/Portfolio';
import ProyectoDetalle from './components/ProyectoDetalle';

function App() {
    return (
        <Router>
            <ScrollManager />
            <div className="App flex flex-col min-h-screen">
                <Header />
                <main className="flex-grow">
                    <Routes>
                        <Route path="/" element={<Home />} />
                        <Route path="/portafolio" element={<PortfolioPage />} />
                        {/* Cada caso tiene URL propia para poder compartirlo. El index.html
                            con los meta tags de cada uno lo genera scripts/generate-og-pages.js
                            durante el build — ver src/hooks/useSeo.ts. */}
                        <Route path="/portafolio/:slug" element={<ProyectoDetalle />} />
                        {/* Un slug viejo o mal copiado cae en la ficha, que muestra su
                            propio "no encontramos ese trabajo" con un link al portafolio. */}
                        <Route path="*" element={<ProyectoDetalle />} />
                    </Routes>
                </main>
                <Footer />
            </div>
        </Router>
    );
}

export default App;
